module.exports = __webpack_public_path__ + "img/team-background.e9a07e76.jpg";